<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19QYj9p/tc-custom/9781466836044.jpg?1724855613316" alt="This image is the cover for the book Donnybrook"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Donnybrook
      </h1>
      <p class="bookDescription body article font2">
        <b>A bareknuckle fighter must win a brutal tournament to feed his family in “a novel that guts the underbelly of southern Indiana”—now a major motion picture (<i>Kirkus Reviews</i>).</b><br/><br/>The Donnybrook is a three-day bare-knuckle tournament held on a thousand-acre plot out in the sticks of southern Indiana. Twenty fighters. One wire-fence ring. Fight until only one man is left standing while a rowdy festival of onlookers—drunk and high on whatever’s on offer—bet on the fighters.<br/><br/>Jarhead is a desperate man who’d do just about anything to feed his children. He’s also the toughest fighter in southeastern Kentucky, and he’s convinced that his ticket to a better life is one last fight with a cash prize so big it’ll solve all his problems. But he’ll have to face Chainsaw Angus—an undefeated fighter who recently got into cooking meth with his sister, Liz.<br/><br/>As we travel through the backwoods to get to the Donnybrook, we meet a cast of nasty, ruined characters driven to all sorts of evil, all in the name of getting their fix—drugs, violence, sex, money, honor. <i>Donnybrook</i> is exactly the fearless, explosive, amphetamine-fueled debut novel you’d expect from the author of the feted and fearless story collection <i>Crimes in Southern Indiana</i>.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Frank Bill
      </h2>
      
      <p class="authorDescription body article"><B>Frank Bill</B> is the author of the story collection <I>Crimes in Southern Indiana</I>, one of <I>GQ</I>'s favorite books of 2011 and a <I>Daily Beast</I> best debut of 2011<I>. </I>He lives and writes in southern Indiana. <I>Donnybrook </I>is his first novel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e575d5f4